/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface TecnicoUpdateDTO
 */
export interface TecnicoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    idNazione: string;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoUpdateDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TecnicoUpdateDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof TecnicoUpdateDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the TecnicoUpdateDTO interface.
 */
export function instanceOfTecnicoUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idNazione" in value;

    return isInstance;
}

export function TecnicoUpdateDTOFromJSON(json: any): TecnicoUpdateDTO {
    return TecnicoUpdateDTOFromJSONTyped(json, false);
}

export function TecnicoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TecnicoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function TecnicoUpdateDTOToJSON(value?: TecnicoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

